import { Box, Skeleton } from "@chakra-ui/react";

import { useMetabaseDashboard } from "../../../hooks/useMetabaseDashboard";

export default function PayoutDashboard() {
  const { iframeUrl, loading, onLoad } = useMetabaseDashboard(72);

  return (
    <Box
      background="#fff"
      border="1px solid #e0e3e6"
      borderRadius="24px"
      padding={6}
      minH="100px"
      height="100%"
    >
      {loading ? (
        <Skeleton
          height="100vh"
          width="100%"
          marginTop={4}
          startColor="gray.100"
          endColor="gray.200"
        />
      ) : null}
      <iframe
        src={iframeUrl}
        onLoad={onLoad}
        title="payout dashboard"
        style={{ width: "100%", minHeight: "100vh", border: "none" }}
      />
    </Box>
  );
}
